  document.addEventListener("DOMContentLoaded", function () {
    var openBtn = document.getElementById("looxReviewBtn");
    var panel = document.getElementById("looxReviewPanel");
    var closeBtn = document.getElementById("looxCloseBtn");

    if (openBtn && panel && closeBtn) {
      openBtn.addEventListener("click", function () {
        panel.classList.add("active");
      });

      closeBtn.addEventListener("click", function () {
        panel.classList.remove("active");
      });
    }
  });
  
document.addEventListener("DOMContentLoaded", function () {

  function updateBuyMoreButtons() {
    document.querySelectorAll(".buy-more-cart").forEach(button => {
      if (button.classList.contains("disabled") || button.disabled) {
        button.textContent = "Added";
      } else {
        button.textContent = "ADD";
      }
    });
  }

  // Run once initially
  updateBuyMoreButtons();

  // Observe dynamic changes (AJAX/cart updates)
  const observer = new MutationObserver(updateBuyMoreButtons);

  observer.observe(document.body, {
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "disabled"]
  });

});
